'use client';

import { Button } from '@ui/components/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/components/card';
import { Input } from '@ui/components/input';
import { Label } from '@ui/components/label';
import { Separator } from '@ui/components/separator';
import { text as sharedText } from '@shared/text';
import { text } from '@modules/auth/text';

import type { SignUpProps } from './sign_up_view_props';
export type { SignUpProps } from './sign_up_view_props';

export function SignUpForm({
  title,
  subtitle,
  submitButtonLabel,
  togglePrompt,
  toggleActionLabel,
  isSubmitting,
  email,
  password,
  onEmailChange,
  onPasswordChange,
  onNavigateToLogin,
  onGuestSignIn,
  onFormSubmit,
}: SignUpProps) {
  return (
    <Card className="w-full max-w-md py-5">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">{title}</CardTitle>
        <CardDescription>{subtitle}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-5">
        <form onSubmit={onFormSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="email">{sharedText.email}</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(event) => onEmailChange(event.target.value)}
              placeholder={sharedText.emailPlaceholder}
              autoCapitalize="none"
              autoComplete="email"
              disabled={isSubmitting}
            />
          </div>

          <div className="flex flex-col gap-2">
            <Label htmlFor="password">{sharedText.password}</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(event) => onPasswordChange(event.target.value)}
              placeholder={sharedText.passwordPlaceholder}
              autoComplete="current-password"
              disabled={isSubmitting}
            />
          </div>

          <Button type="submit" className="w-full" size="lg" disabled={isSubmitting}>
            {submitButtonLabel}
          </Button>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-1">
          <p className="text-muted-foreground text-sm">{togglePrompt}</p>
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto px-0"
            onClick={onNavigateToLogin}
            disabled={isSubmitting}>
            {toggleActionLabel}
          </Button>
        </div>

        <div className="flex items-center gap-3">
          <Separator className="flex-1" />
          <span className="text-muted-foreground text-xs">{sharedText.orDivider}</span>
          <Separator className="flex-1" />
        </div>

        <Button
          type="button"
          variant="outline"
          className="w-full"
          size="lg"
          disabled={isSubmitting}
          onClick={onGuestSignIn}>
          {text.continueAsGuest}
        </Button>
      </CardContent>
    </Card>
  );
}
